module.exports = __webpack_public_path__ + "static/media/iconYellowGroup.1d2471e9.svg";